import { IoChevronForwardSharp } from "react-icons/all";
import React from "react";
import { ToggleButtonProps } from "./types";

export const ToggleButton = ({
  toggle,
  isOpen,
}: ToggleButtonProps): React.ReactElement => (
  <button
    onClick={toggle}
    className="z-1500 absolute top-3 -right-3 flex h-5 w-5 items-center justify-center rounded-full bg-white ring-1 ring-[#00000030] drop-shadow-2xl"
  >
    <IoChevronForwardSharp
      className={`text-tiny text-black shadow-2xl transition-all duration-200	 ${
        isOpen ? "rotate-180" : ""
      }`}
    />
  </button>
);
